module.exports = __webpack_public_path__ + "img/medalha-economia-criativa.b371f0b5.png";